import { getListFileReviewProject } from "@/api/endpoint/reviews/get-list-file-review-project";
import MeeyImage from "@/components/MeeyImage";
import VideoPlayer from "@/components/VideoPlayer";
import { urlRegex } from "@/constants/common-constant";
import { MediaTypeEnum } from "@/constants/enum/media";
import { PAGE_SIZE_FILE } from "@/constants/number";
import { ProjectContext } from "@/context/project.context";
import { ListFileProjectReview } from "Models";
import clsx from "clsx";
import dayjs from "dayjs";
import Link from "next/link";
import { useContext, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

const MAX_FILE_SHOW = 4;

const FileMedia = ({ enableShowFull = true, maxFileShow = MAX_FILE_SHOW }) => {
  const {
    selectedViewFiles,
    setSelectedViewFiles,
    projectListFile,
    setProjectListFile,
    project,
  } = useContext(ProjectContext);

  const [activeTab, setActiveTab] = useState(null);

  const FILE_TAB = [
    {
      label: "Tất cả",
      key: null,
      data: selectedViewFiles?.files,
    },
    {
      label: "Ảnh",
      key: MediaTypeEnum.IMAGE,
      data: selectedViewFiles?.files,
    },
    {
      label: "Video",
      key: MediaTypeEnum.VIDEO,
      data: selectedViewFiles?.files,
    },
    {
      label: "Tài liệu",
      key: MediaTypeEnum.FILE,
      data: selectedViewFiles?.files,
    },
    {
      label: "Link",
      key: MediaTypeEnum.LINK,
      data: selectedViewFiles?.files,
    },
  ];

  const handleChangeTabFile = async (type: number) => {
    const res = await getListFileReviewProject(project?._id, {
      type: type
        ? `${type}`
        : `${MediaTypeEnum.IMAGE},${MediaTypeEnum.VIDEO},${MediaTypeEnum.FILE}`,
      page: 1,
      limit: PAGE_SIZE_FILE,
    });
    if (res) {
      setProjectListFile({
        ...res,
        results: [...res.results],
      });
      setSelectedViewFiles({
        currentFile: null,
        files: [...res.results],
      });
      const listFileElement = document.getElementById("scrollableDiv");
      if (listFileElement) listFileElement.scrollTo(0, 0);
    }
  };

  const onLoadMore = async () => {
    const res = await getListFileReviewProject(project?._id, {
      type: activeTab
        ? activeTab
        : `${MediaTypeEnum.IMAGE},${MediaTypeEnum.VIDEO},${MediaTypeEnum.FILE}`,
      page: projectListFile?.page + 1,
      limit: PAGE_SIZE_FILE,
    });
    if (res) {
      setProjectListFile({
        ...res,
        results: [...projectListFile.results, ...res.results],
      });
      setSelectedViewFiles({
        currentFile: null,
        files: [...projectListFile.results, ...res.results],
      });
    }
  };
  return (
    <div className="bg-white  p-3">
      <div className="flex gap-2">
        {FILE_TAB.map((tab) => (
          <div
            className={clsx(
              "home-tab cursor-default",
              activeTab === tab.key ? "home-tab-active" : ""
            )}
            key={tab?.key}
            onClick={() => {
              if (tab?.key == MediaTypeEnum.LINK) {
                setSelectedViewFiles({
                  currentFile: null,
                  files: [],
                });
              }
              setActiveTab(tab?.key);
              handleChangeTabFile(tab?.key);
            }}>
            <div
              className={clsx(
                "mt-1 mb-4 px-2 py-1 text-fs-12 font-medium rounded-[100px]",
                activeTab === tab.key
                  ? "text-white bg-blue-500"
                  : "text-grey-600 border border-1 border-grey-200 cursor-default md:cursor-pointer bg-grey-50 hover:text-white hover:bg-blue-500"
              )}>
              {tab.label}
            </div>
          </div>
        ))}
      </div>
      <div
        className="max-h-[40vh] overflow-y-auto"
        id="scrollableDiv"
        key={activeTab}>
        <InfiniteScroll
          dataLength={selectedViewFiles?.files?.length || 0}
          next={onLoadMore}
          hasMore={
            selectedViewFiles?.files?.length < projectListFile?.totalResults
          }
          loader={
            <div className="px-4 flex items-center justify-center">
              <div className="dot-flashing" />
            </div>
          }
          scrollableTarget="scrollableDiv">
          {selectedViewFiles?.files?.length ? (
            <>
              <div
                className={
                  activeTab == MediaTypeEnum.LINK
                    ? "flex flex-col"
                    : "grid grid-cols-3 justify-between gap-1"
                }>
                {selectedViewFiles?.files.map((file: ListFileProjectReview) => {
                  return (
                    <div
                      key={file._id}
                      onClick={() => {
                        if (file?.mediaType != MediaTypeEnum.LINK.toString()) {
                          setSelectedViewFiles({
                            currentFile: file,
                            files: selectedViewFiles?.files,
                          });
                        }
                      }}
                      className={clsx(
                        "relative group cursor-pointer",
                        file.mediaType == MediaTypeEnum.IMAGE.toString() ||
                          file.mediaType == MediaTypeEnum.VIDEO.toString()
                          ? "can-preview-upload"
                          : "default-file",
                        file?.mediaType == MediaTypeEnum.LINK.toString()
                          ? ""
                          : "aspect-square"
                      )}
                      // onClick={preview}
                    >
                      {file.mediaType == MediaTypeEnum.IMAGE.toString() ? (
                        <div className=" w-full h-full  bg-grey-200 cursor-pointer">
                          <MeeyImage
                            className="object-cover w-full h-full "
                            src={file.uri}
                            alt={file.name}
                            resizeOnFly={!!file?.uri}
                            resizeOptions={{
                              width: 243,
                              height: 243,
                            }}
                          />
                        </div>
                      ) : file.mediaType == MediaTypeEnum.VIDEO.toString() ? (
                        <div className=" w-full h-full  bg-grey-200 rounded-md flex flex-col relative cursor-pointer">
                          <VideoPlayer
                            options={{
                              autoplay: false,
                              controls: false,
                              responsive: true,
                              fluid: true,
                              preload: "metadata",
                              sources: [
                                {
                                  src: file.urlVod,
                                },
                              ],
                            }}
                          />
                          <div className="absolute top-1/2 left-1/2  -translate-y-1/2 -translate-x-1/2">
                            <i className="mrv mrv-play_arrow text-white text-fs-28 font-bold"></i>
                          </div>
                        </div>
                      ) : file.mediaType == MediaTypeEnum.FILE.toString() ? (
                        <div className="w-full h-full bg-grey-200 rounded-md flex flex-col gap-[66px] relative cursor-pointer border border-transparent border-dashed">
                          <div className="flex-[0_0_24px] w-full flex items-end pt-1">
                            <i className="mrv mrv-attach_file text-fs-24 leading-6"></i>
                            <div className="text-fs-12">
                              .{file?.name?.split(".")?.pop()}
                            </div>
                          </div>
                          <div className="bg-grey-300 flex-[1_1_auto]  text-fs-12 py-1.5 px-2 overflow-hidden  rounded-b-md break-all">
                            <span className="line-clamp-2">{file.name}</span>
                          </div>
                        </div>
                      ) : file?.url ? (
                        <Link href={file?.url} target="_blank">
                          <div className="flex gap-2 items-center w-full py-4 border-b border-solid border-grey-200">
                            <div className="h-8 w-8 p-1 flex items-center justify-center">
                              {file?.favicon?.match(urlRegex) ? (
                                <img src={file?.favicon} alt="dcn" />
                              ) : (
                                <i className="mrv mrv-link text-fs-24 text-black-1000"></i>
                              )}
                            </div>
                            <div className="flex flex-col flex-1">
                              <span
                                className="text-black-1000 text-fs-14 font-medium line-clamp-1 break-word"
                                title={file?.name}>
                                {file?.name}
                              </span>
                              <div className="flex items-center gap-2">
                                <span
                                  className="text-blue-600 text-fs-12 line-clamp-1 break-word"
                                  title={file?.url}>
                                  {file?.url}
                                </span>
                                <div className="text-fs-12 text-grey-500 shrink-0">
                                  {dayjs(file?.createdAt).format("DD/MM/YYYY")}
                                </div>
                              </div>
                            </div>

                            <div>
                              <i className="mrv mrv-more_horiz text-fs-18 text-grey-600"></i>
                            </div>
                          </div>
                        </Link>
                      ) : null}
                      {activeTab !== MediaTypeEnum.LINK ? (
                        <div className="cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100  rounded-md duration-300">
                          <i className="mrv mrv-preview text-white text-fs-28"></i>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="text-grey-500 text-fs-24 font-semibold w-full text-center">
              Chưa có dữ liệu
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default FileMedia;
